import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeadCancelled = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 50 50",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-25 -25)",
		fillRule: "nonzero",
		stroke: "#7a7370",
		strokeWidth: 6.25,
		fill: "none",
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 50,
			cy: 50,
			r: 21.875
		}), /* @__PURE__ */ _jsx("path", { d: "M35.233 34.623l31.032 31.031" })]
	})
});
export default SvgLeadCancelled;
